export default __webpack_public_path__ + "static/media/backgroundjobmgr-hover.bdd8bf12.svg";